SelectBox = App.loadClass 'core::SelectBox'
ValidationEngine = App.loadClass 'core::ValidationEngine'

class exports.AddEditDialog extends DialogHandler

    # TODO: all of this desperately needs to be rewitten with Angular
    # and with more modular views and controller logic

    setInitialDeps: =>
        @syncDeps
            'DialogKO': 'portal::viewmodels/zones/AddEditDialog'

    init: =>
        @ppID = @parent.ppID

        @layoutUrl = 'backend/portal/zones/zones/load-add-edit-dialog'
        @loadLayoutPostOptions ?= {}
        @loadLayoutPostOptions.pp_id = @ppID

        @saveUrl = 'backend/portal/zones/zones/save'

        @classes = 'medium_dialog add_edit_zone_dialog'
        @createDialog()
        @openDialog()
        @displayLoadingMessage('Loading Zone...')


        @validator = new ValidationEngine()


    getPostData: =>
        data =
            counties: []

        # basically writing my own serialization function because jQuery
        # doesn't do things the way I think it should, and we're doing some
        # custom stuff with counties anyway.
        # inputs = @dialog.find('form [name]').each (i,input)->
        for input in @dialog.find('form [name]')
            input = $(input)

            name = input.attr('name')
            if name is '' then continue

            switch name
                when 'zone_counties'
                    for option in input.find('option')
                        data.counties.push $(option).attr('value')
                when 'zone_id'
                    data.sz_id = input.val()
                when 'zone_name'
                    data.name = input.val()
                when 'states', 'state_counties'
                    # skip these
                else
                    data[name] = input.val()

        $.extend(data, @dialog_ko.toJS())

        return data


    afterLoadLayout: (selector, response) =>
        if response.status?.type isnt 'success'
            return

        self = this

        # Find the state with the most counties active in the current zone
        states = {}
        for elem in self.dialog.find('.zone_counties option')
            key = $(elem).attr('data-states-id')
            if states[key]?
                states[key] += 1
            else
                states[key] = 1

            if states[key] > states[max_key] or not max_key?
                max_key = key

        @dialog.find('.sel_state').val(max_key ? '')


        # Filter list of counties by selected state
        @dialog.find('.sel_state').on 'change', ->
            states_id = $(this).val()
            countysel = self.dialog.find('.state_counties')
            counties = self.taffyObjects['counties']( 'states_id': '==': states_id ).select('id', 'cname')
            SelectBox.render(counties, countysel, [])

            # Remove any counties that already are selected
            for elem in self.dialog.find(".zone_counties option[data-states-id='#{states_id}']")
                val = $(elem).attr('value')
                countysel.find("option[value='#{val}']").remove()
            countysel.find('option').attr('data-states-id', states_id)

        # Move counties to the right
        @dialog.find('.btn_county_add').on 'click', =>

            fetch = @countCounties()
            if fetch is true
                @moveOptions(@dialog.find('.state_counties'), @dialog.find('.zone_counties'))
            @_updateYieldUnits()
            @_updateDistribution()

        # Move counties to the left
        @dialog.find('.btn_county_remove').on 'click', =>
            @moveOptions(@dialog.find('.zone_counties'), @dialog.find('.state_counties'))

            # Remove counties that are not in the currently selected state
            states_id = @dialog.find('.sel_state').val()
            @dialog.find(".state_counties option[data-states-id!='#{states_id}']").remove()

            @_updateYieldUnits()
            @_updateDistribution()

        # initialize stuff
        @dialog.find('.sel_state').trigger('change')

        @dialog.find('.info-popover').clickover
            html: true
            container: '.add_edit_zone_dialog'
            placement: 'right'
            trigger: 'hover'

        # validation
        @validator.registerRule
            'selector': '.validate-unique'
            'text': 'Zone Name must be unique'
            'ajax':
                'url': 'backend/portal/zones/zones/validate-zone-name'
                'data': (elem) =>
                    'zone_name': elem.val()
                    'zone_id': @dialog.find('input[name=zone_id]').val()
                    'pp_id': @dialog.find('input[name=pp_id]').val()
            'func': (data) ->
                return data is 'good'

        @validator.makeFormValidator 'edit_zones', '#frm_edit_zones', '#edit_zones_errors', (valid) =>
            if valid
                # Perform an action if the form successfully validated
                @save('Saving...')
            else
                # Perform an action if the form validation failed

        @dialog.find('.save-btn').on 'click', =>
            @validator.validateForm('edit_zones')

        # apply knockout bindings
        @dialog_ko = new (@getDep 'DialogKO') this, response.data
        ko.applyBindings( @dialog_ko, @dialog.find('.step1')[0] )
        ko.applyBindings( @dialog_ko, @dialog.find('.step2')[0] )

        @_updateYieldUnits()
        @_updateDistribution()

        # set the dialog position, now that the content is all loaded
        @setPosition()


    _updateYieldUnits: =>
        counties = @dialog.find('.zone_counties option')

        if counties.length
            # If there are counties associated to the zone, then get the most
            # commonly used units in the zone. Theoretically they should all be
            # the same, but we all know how that goes. Maybe someday we can
            # just select the first county and be done with it.
            possibleUnits = {}

            for county in counties
                id = $(county).attr('data-states-id')

                units = @taffyObjects.states( id: id ).first().yield_units
                if not units? then continue

                if possibleUnits[units]?
                    possibleUnits[units] += 1
                else
                    possibleUnits[units] = 1

            # determine the most common units in the zone
            max = 0
            @bestUnits = null
            for units, count of possibleUnits
                if count > max
                    @bestUnits = units

            # display the selected yield units
            yieldMsg = switch @bestUnits
                when 'bu/ac'
                    "Soil productivity rated in #{@bestUnits}"
                when 'CPI', 'CSR'
                    "Soil productivity rated using #{@bestUnits}"
                else
                    ''
            @dialog.find('#yield_unit_msg').html yieldMsg

            yield_unit_hint = if @bestUnits then "(#{@bestUnits})" else ''
            @dialog.find('#yield_unit_hint').html yield_unit_hint

            # disable any states that don't use the same units
            matchingIDs = @taffyObjects.states( yield_units: @bestUnits ).select('id')
            for id in @taffyObjects.states().select('id')
                el = @dialog.find(".sel_state option[value='#{id}']")
                if id in matchingIDs
                    el.prop('disabled', false)
                else
                    el.prop('disabled', true)

                # TODO: maybe we could also highlight any existing counties
                # with mismatched units and show a pretty warning message about
                # the issue


            # limit the selectable ranges based on the units
            # bu/ac is 0 - unlimited (hardcoded to 500 for now)
            # csr and cpi are both 0 - 100
            if @bestUnits in ['CPI', 'CSR']
                @dialog_ko.setSoilsDefaults(49, 75)
                @dialog_ko.soil_type_max(100)
            else
                @dialog_ko.soil_type_max(500)
                @dialog_ko.setSoilsDefaults(99, 150)

        else
            @dialog.find('#yield_unit_msg').html ''
            @dialog.find('.sel_state option').prop('disabled', false)

            @dialog_ko.soil_type_max(500)
            @dialog_ko.setSoilsDefaults(99, 150)


    _updateDistribution: =>
        highDist = @dialog.find('#high_yield_dist')
        medDist = @dialog.find('#med_yield_dist')
        lowDist = @dialog.find('#low_yield_dist')

        counties = []
        for county in @dialog.find('.zone_counties option')
            counties.push $(county).attr('value')

        if counties.length is 0
            highDist.text('N/A')
            medDist.text('N/A')
            lowDist.text('N/A')

        postParams = counties: counties.join()
        $.post 'backend/portal/zones/zones/get-soil-distribution', postParams, (response) =>
            dist = response.data?.dist
            if not dist?
                @dialog.find('.message_writer').message_writer('error', "There was a problem getting the soil productivity distribution for this zone. We'll try to fix it as soon as possible.")
                return

            units = if units in ['CPI', 'CSR'] then "(#{@bestUnits})" else @bestUnits

            highDist.text if dist.high? then "#{dist.high.min} - #{dist.high.max} #{units}" else 'N/A'
            medDist.text if dist.med? then "#{dist.med.min} - #{dist.med.max} #{units}" else 'N/A'
            lowDist.text if dist.low? then "#{dist.low.min} - #{dist.low.max} #{units}" else 'N/A'


    countCounties: () =>

        addTotal = 0
        existingTotal = 0
        from = @dialog.find('.state_counties')
        to = @dialog.find('.zone_counties')
        counties = @dialog.find('.zone_counties option')
        newList = []


        if from.val()
            for elem in from.val()
                addTotal += 1

        for elem in counties
            existingTotal += 1

        total = addTotal + existingTotal

        if total > 199

            # there are more than 200 counties in the zone

            if existingTotal > 199

                success = false

            else

                # remove enough counties so that we wont go over 200 by adding them

                toAdd = 200 - existingTotal

                for elem in from.val()
                    # if there is space for more counties
                    if toAdd > 0

                        # put one county on the add list
                        newList.push(elem)
                        toAdd -= 1

                for val in newList

                    sel = "option[value='#{val}']"

                    from.find(sel).appendTo(to)
                    from.find(sel).remove()

                success = false

        else
            # there are 200 or less counties in the zone
            success = true

        try
            if success
                # no error
                return success
            else
                # error
                throw success

        catch e
            @dialog.find('.message_writer').message_writer('error', 'Maximum number of counties per zone may not exceed 200.', 4000)
            return false
